// Страница бесплатного мини-теста (16.10.2026, SEO фаза 2): тот же тест из 4
// вопросов, что на главной, и ~300 слов о нём и о полном тесте. Каждое
// утверждение — из FAQ главной (kept-copy.json) и тарифов: 4 вопроса бесплатно,
// полный тест ~30 минут, отчёт ~10 страниц, 8 архетипов на модели Холланда,
// 10–22 года в пяти группах, отчёт на почту и в кабинет, Basic 35 ₼ разово.
import type { SiteLang } from "@/components/site/SiteChrome";

export const FREE_TEST_PATH: Record<SiteLang, string> = {
  ru: "/besplatnyy-test-proforientatsii",
  az: "/az/pulsuz-karyera-testi",
  en: "/en/free-career-test",
};

/** Подпись ссылки в подвале. */
export const FREE_TEST_LABEL: Record<SiteLang, string> = {
  ru: "Бесплатный тест",
  az: "Pulsuz test",
  en: "Free career test",
};

type Copy = {
  meta: { title: string; description: string };
  h1: string;
  lead: string;
  /** Абзацы под тестом: что он показывает, чем отличается полный, сколько стоит. */
  sections: { h2: string; p: string[] }[];
  cta: string;
};

export const FREE_TEST_COPY: Record<SiteLang, Copy> = {
  ru: {
    meta: {
      title: "Бесплатный тест на профориентацию — Yolutap",
      description: "Мини-тест Yolutap: 4 вопроса, минута, без регистрации. Первая подсказка о направлении — и полный тест с отчётом на 10 страниц за 35 ₼.",
    },
    h1: "Бесплатный тест на профориентацию",
    lead: "Четыре вопроса — и первая подсказка, куда тебя тянет. Бесплатно и без регистрации.",
    sections: [
      {
        h2: "Что показывает мини-тест",
        p: [
          "Мини-тест Yolutap занимает около минуты. Ты отвечаешь на четыре вопроса — что интереснее, как проводишь свободный вечер, какую роль берёшь в команде и что важнее в будущей работе. По ответам тест показывает, какое из четырёх направлений звучит сильнее: Создатель — тебя тянет придумывать и создавать; Исследователь — интересно понимать, как устроен мир; Наставник — важны люди и помощь им; Организатор — умеешь вести и доводить до результата.",
          "Это подсказка, а не профиль. Четыре ответа не описывают человека целиком — они дают повод задуматься и поговорить с семьёй.",
        ],
      },
      {
        h2: "Чем отличается полный тест",
        p: [
          "Полный тест Yolutap идёт около 30 минут. В его основе — три проверенные модели: Дональд Супер (карьерное развитие), Джон Холланд / RIASEC (связь интересов и профессий) и Жан Пиаже (возрастное развитие). Восемь архетипов Yolutap построены на модели Холланда. Тест и отчёт адаптированы под пять возрастных групп: 10–11, 12–13, 14–15, 16–18 и 18–22 года.",
          "По итогам приходит персональный отчёт примерно на 10 страниц: архетипы, сильные стороны и направления. Отчёт приходит на почту, указанную при оплате, и навсегда остаётся в личном кабинете. Это ориентир, а не диагноз: решения остаются за тобой и семьёй. Тест доступен на русском, азербайджанском и английском.",
        ],
      },
      {
        h2: "Кому подойдёт",
        p: [
          "Мини-тест подойдёт школьнику, студенту и родителю, который хочет начать разговор о будущей профессии. Если результат показал два направления почти поровну — это нормально: у многих интересы смешанные. В полном отчёте вместо четырёх направлений — восемь архетипов. Данные полного теста хранятся в ЕС (Франкфурт), мы их не продаём; для тех, кому нет 18, нужно согласие родителя.",
        ],
      },
      {
        h2: "Сколько стоит",
        p: ["Мини-тест бесплатный. Полный тест с отчётом — тариф Basic, 35 ₼ одним платежом, без подписки."],
      },
    ],
    cta: "Пройти полный тест — 35 ₼",
  },
  az: {
    meta: {
      title: "Pulsuz karyera testi — Yolutap",
      description: "Yolutap mini-testi: 4 sual, bir dəqiqə, qeydiyyatsız. İstiqamət üzrə ilk ipucu — və 10 səhifəlik hesabatla tam test 35 ₼-a.",
    },
    h1: "Pulsuz karyera testi",
    lead: "Dörd sual — və səni nəyin cəlb etdiyinə dair ilk ipucu. Pulsuz və qeydiyyatsız.",
    sections: [
      {
        h2: "Mini-test nəyi göstərir",
        p: [
          "Yolutap mini-testi təxminən bir dəqiqə çəkir. Dörd suala cavab verirsən — nə daha maraqlıdır, boş axşamı necə keçirirsən, komandada hansı rolu götürürsən və gələcək işdə nə daha vacibdir. Cavablara görə test dörd istiqamətdən hansının daha güclü səsləndiyini göstərir: Yaradıcı — səni düşünmək və yaratmaq cəlb edir; Araşdırmaçı — dünyanın necə işlədiyini anlamaq maraqlıdır; Mentor — insanlar və onlara kömək sənin üçün vacibdir; Təşkilatçı — yönləndirib nəticəyə çatdırmağı bacarırsan.",
          "Bu, profil deyil, ipucudur. Dörd cavab insanı tam təsvir etmir — düşünmək və ailə ilə danışmaq üçün səbəb verir.",
        ],
      },
      {
        h2: "Tam test nə ilə fərqlənir",
        p: [
          "Yolutap-ın tam testi təxminən 30 dəqiqə çəkir. Əsasında üç sınaqdan keçmiş model dayanır: Donald Super (karyera inkişafı), John Holland / RIASEC (maraqlarla peşələr arasındakı əlaqə) və Jean Piaget (yaşa görə inkişaf). Yolutap-ın 8 arxetipi Holland modeli üzərində qurulub. Test və hesabat beş yaş qrupuna uyğunlaşdırılıb: 10–11, 12–13, 14–15, 16–18 və 18–22 yaş.",
          "Nəticədə təxminən 10 səhifəlik fərdi hesabat gəlir: arxetiplər, güclü tərəflər və istiqamətlər. Hesabat ödəniş zamanı göstərilən elektron poçta gəlir və şəxsi kabinetdə həmişəlik saxlanılır. Bu, diaqnoz deyil, istiqamətdir: qərarlar sənin və ailənindir. Test Azərbaycan, rus və ingilis dillərindədir.",
        ],
      },
      {
        h2: "Kimə uyğundur",
        p: [
          "Mini-test məktəbliyə, tələbəyə və gələcək peşə barədə söhbətə başlamaq istəyən valideynə uyğundur. Nəticə iki istiqaməti təxminən bərabər göstəribsə, bu normaldır: çoxlarının maraqları qarışıqdır. Tam hesabatda dörd istiqamət əvəzinə səkkiz arxetip var. Tam testin məlumatları AB-də (Frankfurt) saxlanılır, onları satmırıq; 18 yaşı tamam olmayanlar üçün valideyn razılığı lazımdır.",
        ],
      },
      {
        h2: "Qiyməti nə qədərdir",
        p: ["Mini-test pulsuzdur. Hesabatla tam test — Basic tarifi, bir ödənişlə 35 ₼, abunəsiz."],
      },
    ],
    cta: "Tam testdən keç — 35 ₼",
  },
  en: {
    meta: {
      title: "Free career test — Yolutap",
      description: "The Yolutap mini-test: 4 questions, one minute, no sign-up. A first hint about your direction — and the full test with a 10-page report for 35 ₼.",
    },
    h1: "Free career test",
    lead: "Four questions — and a first hint about what draws you. Free, no sign-up.",
    sections: [
      {
        h2: "What the mini-test shows",
        p: [
          "The Yolutap mini-test takes about a minute. You answer four questions — what interests you more, how you spend a free evening, which role you take in a team and what matters most in future work. From your answers the test shows which of four directions sounds strongest: Creator — you're drawn to inventing and making; Explorer — you love understanding how things work; Mentor — people and helping them matter to you; Organizer — you lead and get things done.",
          "It's a hint, not a profile. Four answers don't describe a whole person — they give you a reason to think and to talk it over with your family.",
        ],
      },
      {
        h2: "How the full test is different",
        p: [
          "The full Yolutap test takes about 30 minutes. It draws on three established models: Donald Super (career development), John Holland / RIASEC (the link between interests and professions) and Jean Piaget (age-related development). Yolutap's 8 archetypes are built on Holland's model. The test and report are adapted to five age groups: 10–11, 12–13, 14–15, 16–18 and 18–22.",
          "You get a personalized report of about 10 pages: archetypes, strengths and directions. It is sent to the email you give at checkout and kept in your personal account for good. The report is a guide, not a diagnosis: the decisions stay with you and your family. The test is available in English, Russian and Azerbaijani.",
        ],
      },
      {
        h2: "Who it's for",
        p: [
          "The mini-test suits a school student, a university student or a parent who wants to start a conversation about a future career. If the result shows two directions almost equally, that's normal: many people have mixed interests. The full report uses eight archetypes instead of four directions. Data from the full test is stored in the EU (Frankfurt) and we don't sell it; anyone under 18 needs a parent's consent.",
        ],
      },
      {
        h2: "What it costs",
        p: ["The mini-test is free. The full test with the report is the Basic plan: 35 ₼, one payment, no subscription."],
      },
    ],
    cta: "Take the full test — 35 ₼",
  },
};
